function addItemAmount () {
    var amount = parseInt($(".amount").val());
    amount++
    $(".amount").val(amount);
    if (amount > 1) {
        $('.minus').prop('disabled', false);
    }
}
function subtractItemAmount () {
    var amount = parseInt($(".amount").val());
    amount--
    $(".amount").val(amount);
    if (amount <= 1) {
        $('.minus').prop('disabled', true);
    }
}

/* multiple variant selector: update add-to-cart button when a variant button is clicked */
$(document).on('click', '.post-card-multi-purpose .pcmu-variant-btn', function() {
    var variantBtn = $(this);
    if (variantBtn.hasClass('active')) return;
    var parentInfo = variantBtn.closest('.pcmu__info');
    var addToCartBtn = parentInfo.find('.addSingleItemToCart');
    if (!addToCartBtn.length) return;

    variantBtn.siblings('.pcmu-variant-btn').removeClass('active');
    variantBtn.addClass('active');

    var variantId = variantBtn.data('variant-id');
    var priceFormatted = variantBtn.data('price-formatted');
    var priceTimes4Formatted = variantBtn.data('price-times-4-formatted');
    var available = variantBtn.data('available');

    addToCartBtn.data('variant', variantId);
    addToCartBtn.data('available', available);
    addToCartBtn.attr('data-variant', variantId);
    addToCartBtn.attr('data-available', available);

    if (available) {
        addToCartBtn.prop('disabled', false).removeClass('no-stock');
        if (addToCartBtn.find('.btn-text.addbag').length) {
            addToCartBtn.find('.btn-text.addbag').text('add to bag');
        } else {
            addToCartBtn.html('<span class="btn-text normal">' + priceFormatted + '</span><span class="btn-text discount"> ' + priceTimes4Formatted + '</span><span class="btn-text space"> | </span><span class="btn-text addbag">add to bag</span><span class="added">added to cart!</span>');
        }
    } else {
        addToCartBtn.prop('disabled', true).addClass('no-stock');
        if (addToCartBtn.find('.btn-text.addbag').length) {
            addToCartBtn.find('.btn-text.addbag').text('out of stock');
        } else {
            addToCartBtn.text('out of stock');
        }
    }

    var normalSpan = addToCartBtn.find('.btn-text.normal');
    var discountSpan = addToCartBtn.find('.btn-text.discount');
    if (normalSpan.length) normalSpan.text(priceFormatted);
    if (discountSpan.length) discountSpan.text(' ' + priceTimes4Formatted);
});

$('.pack-selector').on('click', function() {
    var btn = $(this),
        qty = btn.data('qty'),
        price = btn.closest(".packs").data("price").replace("$", ""),
        discountedPrice = Number(price) - (Number(price) * .10);
        amountTargetElement = btn.closest(".packs").find("input"),
        priceTargetElement = btn.closest(".packs").find(".price"),
        discountedPriceTargetElement = btn.closest(".packs").find(".pack-discounted-price"),
        targetClass = btn.closest(".packs");
        priceTargetElementButton = btn.closest(".pcmu__info").find(".btn-text.normal"),
        priceTargetElementButtonDiscount = btn.closest(".pcmu__info").find(".btn-text.discount"),

    btn.parent().find(".pack-selector").removeClass('active');
    btn.addClass('active');
    amountTargetElement.val(qty);

    if(qty >= 4) {
        targetClass.addClass('discount-is-active');
        discountedPriceTargetElement.html('$' + discountedPrice.toFixed(2));
        priceTargetElement.html('$' + (discountedPrice.toFixed(2) * qty));
        priceTargetElementButton.html('$' + (discountedPrice.toFixed(2) * qty));
        priceTargetElementButtonDiscount.show();
    } else {
        targetClass.removeClass('discount-is-active');
        priceTargetElement.html('$' + (price * qty));
        priceTargetElementButton.html('$' + (price * qty));
        priceTargetElementButtonDiscount.hide();
    }
})

$('.addSingleItemToCart').on('click', function() {
    var btn = $(this),
        pack = btn.data('pack'),
        variant_id = btn.data('variant'),
        discountProperty = btn.data('discount-property'),
        qty = btn.parent().find("input").val(),
        threshold = 4;

    if (btn.prop('disabled') || btn.hasClass('adding')) return;
    btn.prop('disabled', true).addClass('adding');

    if(pack) {
        if(qty >= threshold) {  
            console.log('Pack is greater than or equal to ' + threshold);
            var item_data = {
                quantity: qty,
                id: variant_id,
                properties: {
                    '_is_bundle': false,
                    '_Discount': 'Pack',
                    '_attribution': 'Pack'
                }
            }
        } else {
            var item_data = {
                quantity: qty,
                id: variant_id,
                properties: {
                    '_is_bundle': false,
                    '_attribution': 'One Time Purchase'
                }
            }
        }
    } else {
        if(discountProperty != 'Pack') {
            var item_data = {
                quantity: qty,
                id: variant_id,
                properties: {
                    '_is_bundle': false,
                    'Discount': discountProperty,
                    '_attribution': 'One Time Purchase'
                }
            }
        } else {
            var item_data = {
                quantity: qty,
                id: variant_id,
                properties: {
                    '_is_bundle': false,
                    '_attribution': 'One Time Purchase'
                }
            }
        }
    }

    $.ajax({
        url: '/cart/add.json',
        type: 'post',
        dataType: 'json',
        data: item_data,
        success: function(response) {
            console.log('');
            console.log('%c' + response.title + "%c was added to cart.", 'color: green','color: black',);

            if(showVueCart == true) {
                window.miniCart.refreshCart();
            }
            btn.removeClass('adding');
            if(qty >= 4) {
                btn.closest(".pcmu__info").find(".added").show();
                btn.closest(".pcmu__info").find(".btn-text").hide()
                btn.prop('disabled', true);

                setTimeout(function() {
                    btn.closest(".pcmu__info").find(".added").hide();
                    btn.closest(".pcmu__info").find(".btn-text").show()
                    btn.prop('disabled', false);
                }, 3000)
            } else {
                btn.closest(".pcmu__info").find(".btn-text.normal").hide();
                btn.closest(".pcmu__info").find(".btn-text.space").hide();
                btn.closest(".pcmu__info").find(".btn-text.addbag").hide();
                btn.closest(".pcmu__info").find(".added").show();
                btn.closest(".pcmu__info").find(".pack-selector").prop('disabled', true);
                btn.prop('disabled', true);

                setTimeout(function() {
                    btn.closest(".pcmu__info").find(".btn-text.normal").show();
                    btn.closest(".pcmu__info").find(".btn-text.space").show();
                    btn.closest(".pcmu__info").find(".btn-text.addbag").show();
                    btn.closest(".pcmu__info").find(".added").hide();
                    btn.closest(".pcmu__info").find(".pack-selector").prop('disabled', false);
                    btn.prop('disabled', false);
                }, 3000)
            }
        },
        error: function(response) {
            btn.removeClass('adding').prop('disabled', false);
            if (response && response.responseText) {
                try {
                    var errors = JSON.parse(response.responseText);
                    console.log(errors.errors);
                } catch (e) {}
                }
        }
    });
})

/* bundles */
$('.post-card-multi-purpose #bundleAddToCart').on('click', function() {
    var bundleQuantity = $('.post-card-multi-purpose .amount').val();
    console.log("dasdsa")
    var btn = $(this),
        variant_id = btn.data('variant'),
        productTitle = btn.data('product-title');
        
    var bundleItems = btn.data('bundle-items').items[0],
        items = [];

    for(i=0; i < bundleItems.length; i++) {
        items.push({
            quantity: bundleItems[i].quantity * bundleQuantity,
            id: bundleItems[i].variant_id,
            properties: {
                'Bundle': productTitle
            }
        });
    }

    jQuery.post('/cart/add.js', {
        items: items,
        success: function() {
            console.log('Added bundle to cart with =>', items);

            setTimeout(function() {
                if(showVueCart == true) {
                    window.miniCart.refreshCart();
                }
            }, 2000);
        }
    });
});